import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { url: String }

  navigate(event) {
    // Allow default behaviour for Ctrl+click, Meta+click (Cmd on Mac), middle-click, right-click
    if (event.ctrlKey || event.metaKey || event.button !== 0 || event.altKey) {
      return
    }

    // Prevent navigation if triggered by an action button
    if (event.target.closest('[data-action*="preventNavigation"]')) {
      return
    }

    event.preventDefault()
    Turbo.visit(this.urlValue)
  }

  preventNavigation(event) {
    event.stopPropagation();
  }
}